import axios from 'axios';

const ajax = {
  // 获取i18n种类
  GET_LANGUAGE_TYPE: '/get/i18n_type',

  // 获取首页menuList
  GET_MENU_LIST: 'homePageMenuImgList',

  // 获取头部导航菜单
  // GET_HEADER_LIST: '/headerList',
};

// 获取有权限的子菜单
const GET_GRANTED_SUBMENU = 'platform/v1/resources/granted/submenu'

// 获取单个影像件
const GET_IMAGE_BYTE = 'attachment/v1/media/byte?';

// 机构
const SALE_BRANCHS = 'https://dev-api.zjlh.lan/apply/v1/input/salebranchs?';

// 异常问题
const ABNORMAL_PROBLEM = 'https://dev-api.zjlh.lan/agent/v1/process/commission/exception/questions?';

// mock公共部分
const API_PATH_PRE_FIX = '/api';

const FIRST_PARAM_JOINT_MARK = '?'
// 退出系统
const LOGOUT = 'auth/user/logout'
// 增加前缀
let INTERFACE = {};
for (let key in ajax) {
  INTERFACE[key] = API_PATH_PRE_FIX + ajax[key];
}

/**
 * 获取 i18n 的种类
 */
function getI18nType() {
  // 这里需要先调用后端保存的语言
  return axios.get(INTERFACE.GET_LANGUAGE_TYPE);
}

/**
 * 获取i18n 配置json
 *
 * @param language
 * @private
 */
function getI18n(language = 'ZH_CN') {
  return axios.get('/static/i18n/' + language + '/index.json' + '?').then((data) => {
    window.I18n = data;
  });
}

/**
 * 获取头部导航菜单
 */
// function getHeaderList() {
//   return axios.get(INTERFACE.GET_HEADER_LIST).catch(function (error) {
//     console.log(error)
//   });
// }

function getHeaderList() {
  var data = {
    parentMenuValue: '/',
    serviceName: window.localStorage.serviceName,
    httpMethod: 'GET',
    parentType: 'FRONTEND_DOMAIN',
    childType: 'FRONTEND_URL'
  }
  return axios.get(GET_GRANTED_SUBMENU + '?', {params: data}).catch(function (error) {
    console.log(error)
  });
}

/**
 * 获取首页menuList
 */
function getMenuList() {
  return axios.get(INTERFACE.GET_MENU_LIST).catch(function (error) {
    window.Alert(error);
  });
}

/**
 * 获取单个影像件
 * @param data
 * @returns {Promise.<T>}
 */
function getImageByte(data) {
  return axios.get(GET_IMAGE_BYTE, {
    params: data
  }).catch(function (error) {
    window.Alert(error);
  });
}

/**
 * 获取机构
 */
function getSaleBarnchs() {
  return axios.get(SALE_BRANCHS).catch(function (error) {
    window.Alert(error);
  });
}

/**
 * 获取异常问题
 */
function getAbnormalProblem() {
  return axios.get(ABNORMAL_PROBLEM).catch(function (error) {
    window.Alert(error);
  });
}

var baseUrl = 'finance'

function getsaleList() {
  var c = 'platform/v1/manager/branch/trees'
  return axios.get(c).catch(function (error) {
    window.Alert(error);
  })
}

function logout() {
  return axios.get(LOGOUT + FIRST_PARAM_JOINT_MARK).catch(function (error) {
    window.Alert(error);
  });
}

export default {
  getI18n,
  getI18nType,
  getHeaderList,
  getImageByte,
  getSaleBarnchs,
  getAbnormalProblem,
  baseUrl,
  getsaleList,
  logout,
  getMenuList
};



// WEBPACK FOOTER //
// ./src/interface.js